import { render, staticRenderFns } from "./CreateSpaceSuccess.vue?vue&type=template&id=94b810a0&scoped=true&"
import script from "./CreateSpaceSuccess.vue?vue&type=script&lang=ts&"
export * from "./CreateSpaceSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSpaceSuccess.vue?vue&type=style&index=0&id=94b810a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b810a0",
  null
  
)

export default component.exports